import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'
import {MdAttachFile}  from 'react-icons/md'
import { useRef } from 'react';
import emailjs from 'emailjs-com'
import { contactusdata } from '../../data';
import Footer from '../../components/Footer'

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_3fjfb17', 'template_ky1ucaz', form.current, 'user_641J0AWGxx4qcKi835yDq')
  
      e.target.reset()
    };

  return (
    <section className="contact">
        <div className='contact__form'>
            <div className="container contact-title-container">
                <h1>Have a project?</h1>
                <h1>We would love to help.</h1>
                <p>FILL OUT THE FORM</p>
            </div>
            <div className="container contact-container">
                {/* END OF CONTACT OPTIONS */}
                <form ref={form} onSubmit={sendEmail}>
                    <input type="text" name='name' placeholder='NAME' required />
                    <input type="email" name='email' placeholder='YOUR EMAIL' required />
                    <textarea name="message" rows={7} placeholder='TELL US ABOUT YOUR PROJECT' required ></textarea>
                    <div className='contact_btn_container'>
                        <button type='file' name='file' className='contact__attachment_btn'><MdAttachFile className='contact__attachment_icon'/> Add Attachment</button>
                        <button type='submit' className='white_btn'>Send Message</button>
                    </div>
                </form>
                <p className='agreement'>
                    I agree that my data in this form will be sent to contact@mm-space.com and will be read by human beings. We will answer you as soon as possible. If you sent this form by mistake or want to remove your data, you can let us know by sending an email to contact@prographers.com. We will never send you any spam or share your data with third parties
                </p>
            </div>
        </div>
        <div className='contact__directcontact'>
            <div className="container directcontact-container">
                <h1>Direct Contact</h1>
                <div className='contact__collumnwrapper'>
                    {/*
                    <div className="contact__options">
                        <h4 className='city'>Melbourne, {new Date().toLocaleString("en-US", {timeZone:'Australia/Melbourne',timestyle:'short', hourCycle:'h24'})}</h4>
                        <article className="contactus__option">
                            <div className='contactus__option-top'>
                                <p>Write To Us</p>
                                <MdOutlineEmail className='contactus__option-icon'/>
                            </div>
                            <a href={`'mailto:' + ${contactusdata[0].email}`} target="_blank">{contactusdata[0].email}</a>
                        </article>
                        <article className="contactus__option">
                            <div className='contactus__option-top'>
                                <p>Messenger Us</p> 
                                <RiMessengerLine className='contactus__option-icon2'/>
                            </div>
                            <a href="https://m.me/ernest.achiever" target="_blank">{contactusdata[0].messenger}</a>
                        </article>
                        <article className="contactus__option">
                            <div className='contactus__option-top'>
                                <p>Call or WhatsApp Us</p>
                                <BsWhatsapp className='contactus__option-icon3'/>
                            </div>
                            <a href={`"https://api.whatsapp.com/send?phone=" + ${contactusdata[0].whatsapp}`} target="_blank">{contactusdata[0].whatsapp}</a>
                        </article>
                    </div>
                    */}
                     <div className="contact__options">
                        <h4 className='city'>Hong Kong, {new Date().toLocaleString("en-US", {timeZone:'Asia/Hong_Kong',timestyle:'short', hourCycle:'h24'})}</h4>
                        <article className="contact__option">
                        <h4 className='city'>Address</h4>
                            <div className='contactus__option-top'>
                        <p>
                            Shop B13A, Basement Floor, Worfu, 21-53 Whaef Road, North Point, Hong Kong
                        </p>
                        </div>
                        </article>
                        <article className="contactus__option">
                            <div className='contactus__option-top'>
                                <p>Write To Us</p>
                                <MdOutlineEmail className='contactus__option-icon'/>
                            </div>
                            <a href={`'mailto:' + ${contactusdata[1].email}`} target="_blank">{contactusdata[1].email}</a>
                        </article>
                        <article className="contactus__option">
                            <div className='contactus__option-top'>
                                <p>Messenger Us</p> 
                                <RiMessengerLine className='contactus__option-icon2'/>
                            </div>
                            <a href="https://m.me/ernest.achiever" target="_blank">{contactusdata[1].messenger}</a>
                        </article>
                        <article className="contactus__option">
                            <div className='contactus__option-top'>
                                <p>Call or WhatsApp Us</p>
                                <BsWhatsapp className='contactus__option-icon3'/>  
                            </div>
                            <a href={`"https://api.whatsapp.com/send?phone=" + ${contactusdata[1].whatsapp}`} target="_blank">{contactusdata[1].whatsapp}</a>
                        </article>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </section>
  )
}

export default Contact